import { useEffect } from "react";

export default function GoogleCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    if (code && window.opener) {
      window.opener.postMessage({
        type: "google-oauth-callback",
        code,
        redirect_uri: window.location.origin + "/google-callback",
      }, window.location.origin);
      window.close();
    }
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen">
      <p className="text-sm text-zinc-500">Collegamento in corso... Puoi chiudere questa finestra.</p>
    </div>
  );
}
